import React from "react";
import { useVeltClient } from "../context";
export function useCrdtUtils() {
    var _a = React.useState(), crdtElement = _a[0], setCrdtElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || crdtElement)
            return;
        var loadedCrdtElement = client.getCrdtElement();
        setCrdtElement(loadedCrdtElement);
    }, [client, setCrdtElement, crdtElement]);
    return crdtElement;
}
